import { render, staticRenderFns } from "./TemplateItem.vue?vue&type=template&id=a40ae362"
import script from "./TemplateItem.vue?vue&type=script&lang=js"
export * from "./TemplateItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports